let currentLayoutClass = ''

export default function setLayoutClass (className) {
  const html = document.querySelector('html')
  if (currentLayoutClass) {
    html.classList.remove(currentLayoutClass)
    currentLayoutClass = className
  }
  html.classList.add(className)
}
